// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2QiJe","content":"Consent_content__10PEA","footer":"Consent_footer__31CoU"};